export default {
    state: {
        items: null,
        loading: {
            items: false
        }
    },
    getters: {
        publicItems: state => state.items,
        publicItemsLoading: state => state.loading
    },
    mutations: {
        SET_ITEMS(state, items) {
            state.items = items
        },
        START_LOADING_ITEMS(state) {
            state.loading.items = true
        },
        FINISH_LOADING_ITEMS(state) {
            state.loading.items = false
        }
    },
    actions: {
        async getPublicItems({ commit }) {
            commit('START_LOADING_ITEMS')

            const url = '/public/items?sort_by=New'

            try {
                const resp = await this.$axios.get(url)

                commit('SET_ITEMS', resp.data)
            } finally {
                commit('FINISH_LOADING_ITEMS')
            }
        }
    }
}
